<script lang="ts">
	import { reveal } from '$lib/actions/reveal';
	import { magnetic } from '$lib/actions/magnetic';
	import posthog from 'posthog-js';
</script>

<section
	aria-labelledby="hero-heading"
	class="relative mx-auto mt-16 flex w-full max-w-[1000px] flex-col self-center px-4 text-white sm:mt-24 lg:mt-32 lg:px-0"
>
	<h1
		id="hero-heading"
		class="text-gradient-enterprise reveal reveal-delay-1 text-center font-display text-[36px] font-medium leading-[1.05] tracking-[-0.025em] sm:text-[56px] lg:text-[76px]"
		use:reveal
	>
		The operating system for edge infrastructure
	</h1>
	<p
		class="reveal reveal-delay-2 mx-auto mt-6 max-w-[640px] text-center font-display text-base leading-[1.6] text-white/65 sm:mt-8 sm:text-lg lg:text-xl"
		use:reveal
	>
		Manage thousands of Linux devices as easily as one. Ship software, OTA updates, and security
		patches to your entire fleet from a single dashboard.
	</p>
	<div
		class="reveal reveal-delay-3 mt-8 flex flex-col justify-center gap-3 sm:mt-10 sm:flex-row"
		use:reveal
	>
		<a
			use:magnetic
			href="https://app.admrl.co/signup"
			onclick={() => posthog.capture('hero_cta_clicked')}
			class="btn-primary inline-flex h-12 items-center justify-center rounded-md px-7 font-display text-sm font-medium"
		>
			Get started for free
		</a>
		<a
			use:magnetic
			href="https://docs.admrl.co"
			target="_blank"
			rel="noopener"
			onclick={() => posthog.capture('hero_docs_clicked')}
			class="btn-secondary inline-flex h-12 items-center justify-center gap-2 rounded-md px-7 font-display text-sm font-medium"
		>
			Read the docs
			<svg class="h-4 w-4" viewBox="0 0 16 16" fill="none"
				><path
					d="M6 3l5 5-5 5"
					stroke="currentColor"
					stroke-width="1.5"
					stroke-linecap="round"
				/></svg
			>
		</a>
	</div>
	<p class="reveal reveal-delay-4 mt-6 text-center font-display text-xs text-white/45" use:reveal>
		First 5 devices free forever · No credit card required · Design partner slots open
	</p>
	<p class="sr-only">
		Admiral is an edge computing platform and Linux fleet management solution. It provides OTA
		over-the-air updates, container orchestration, device monitoring, and security compliance for
		IoT and embedded Linux devices. Admiral is a modern alternative to Mender, Balena, and JFrog
		Connect for managing edge device fleets at scale across industries including industrial IoT,
		digital signage, agriculture, and mining.
	</p>
</section>
